import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/airplane.json";

const splashScreen = {
  enabled: false, // set false to disable splash screen
  animation: splashAnimation,
  duration: 1000 // Set animation duration as per your animation
};

const greeting = {
  username: "Romeo Natchkebia",
  title: "Hi all, I'm Romeo",
  subTitle: emoji(
    "A passionate Front-End Software Developer 🚀 having an experience of building Web and Mobile applications with JavaScript / Reactjs / Nodejs / React Native and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1pPo90nQvrOnQT4ee0e5I3Ni8BbhLWooQ/view?usp=drive_link",
  displayGreeting: true
};

// Social Media Links
const socialMediaLinks = {
  github: "https://github.com/romeonatchkebia",
  linkedin: "https://www.linkedin.com/in/romeo-natchkebia-13a69925b",
  gmail: "romeonatchkebia@gmail.com",
  facebook: "https://www.facebook.com/romeo.natchkebia",
  medium: "https://medium.com/@romeo.nachkebia"
};

// Skills Section

const skillsSection = {
  title: "What I Do",
  subTitle:
    "Versatile Full Stack Developer with a Strong Frontend Focus, Passionate About Building End-to-End Solutions Across the Tech Stack",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji(
      "⚡ Experienced with a wide range of JavaScript libraries and frameworks, with a strong focus on React, React Native, Next.js"
    ),
    emoji(
      "⚡ Scalable backend systems using Node.js with SQL and NoSQL databases"
    ),
    emoji("⚡ Cross-platform mobile apps using React Native and Expo"),
    emoji(
      "⚡ Unit and UI testing with Jest and Maestro for web and mobile apps"
    )
  ],
  softwareSkills: [
    {skillName: "html-5", fontAwesomeClassname: "fab fa-html5"},
    {skillName: "css3", fontAwesomeClassname: "fab fa-css3-alt"},
    {skillName: "sass", fontAwesomeClassname: "fab fa-sass"},
    {skillName: "JavaScript", fontAwesomeClassname: "fab fa-js"},
    {skillName: "reactjs", fontAwesomeClassname: "fab fa-react"},
    {skillName: "nextjs", fontAwesomeClassname: "fas fa-code"},
    {skillName: "react native", fontAwesomeClassname: "fab fa-react"},
    {skillName: "angular", fontAwesomeClassname: "fab fa-angular"},
    {skillName: "nodejs", fontAwesomeClassname: "fab fa-node"},
    {skillName: "sql-database", fontAwesomeClassname: "fas fa-database"},
    {skillName: "no-sql database", fontAwesomeClassname: "fas fa-server"},
    {skillName: "aws", fontAwesomeClassname: "fab fa-aws"},
    {skillName: "firebase", fontAwesomeClassname: "fas fa-fire"},
    {skillName: "jest", fontAwesomeClassname: "fas fa-vial"},
    {skillName: "maestro", fontAwesomeClassname: "fas fa-mobile"} // best fit for mobile testing
  ]
};

// Education Section

const educationInfo = {
  schools: [
    {
      schoolName: "Digital Institute",
      logo: require("./assets/images/digital_institute.webp"),
      subHeader: "Backend Development Course (Node.js)",
      duration: "March 2024 - September 2024",
      desc: "Focused on backend development fundamentals, building scalable server-side applications using Node.js and related technologies.",
      descBullets: [
        "Developed RESTful APIs and integrated databases with Node.js and Express",
        "Implemented authentication, authorization, and security best practices",
        "Built a capstone project featuring a full backend for a social app"
      ]
    },
    {
      schoolName: "Digital Institute",
      logo: require("./assets/images/digital_institute.webp"),
      subHeader: "Frontend Development Course (React, React Native)",
      duration: "December 2022 - May 2023",
      desc: "Studied core principles of web and mobile development, focusing on key frameworks and modern design practices.",
      descBullets: [
        "Gained hands-on experience building responsive user interfaces with React and React Native",
        "Learned best practices for component-based architecture and state management",
        "Created an Uber Eats clone app as a capstone project"
      ]
    },
    {
      schoolName: "Tbilisi State University",
      logo: require("./assets/images/TSU_Logo.webp"),
      subHeader: "Bachelor of Science in Psychology",
      duration: "September 2018 - August 2022",
      desc: "Graduated in the top 10% of the program. Focused on human behavior, cognitive processes, and research methodologies.",
      descBullets: [
        "Conducted research projects analyzing cognitive and behavioral patterns",
        "Gained strong analytical and problem-solving skills through experimental psychology",
        "Developed communication and user-centered thinking applicable to technology"
      ]
    }
  ]
};

// Work experience section

const workExperiences = {
  experience: [
    {
      role: "Software Engineer",
      company: "Broccoli Agency",
      companylogo: require("./assets/images/broccoli_agency_logo.webp"),
      date: "September 2024 – Present",
      desc: "Contributed to multiple projects, enhancing functionality and user experience across web applications.",
      descBullets: [
        "Maximized website visibility through improved SEO",
        "Developed a custom content management system for a blog web application",
        "Created a full-stack app for hotels with Angular (admin, client-side) and .NET backend"
      ]
    },
    {
      role: "Front-End Developer",
      company: "Rise",
      companylogo: require("./assets/images/rise.webp"),
      date: "November 2023 – June 2024",
      desc: "Contributed to the development of productivity applications focusing on cross-platform performance and seamless integration with key communication tools.",
      descBullets: [
        "Developed and implemented a customized productivity app using react native",
        "Streamlined user experience through integration ofvarious communication tools including Jira, Gmail,Google News and Slack.",
        "Developed a responsive and interactive web application by implementing React for a productivity app"
      ]
    },
    {
      role: "React Native Developer",
      company: "Concept Digital",
      companylogo: require("./assets/images/conceptDigital.webp"),
      date: "Jun 2023 – November 2023",
      desc: "Worked on developing and optimizing a responsive mobile app delivering timely business and economic news. Collaborated closely with cross-functional teams to enhance app performance and user experience.",
      descBullets: [
        "This project developed a responsive, user-friendly interface for easy access to timely business and economic news on mobile devices (BMG mobile app)",
        "Collaborated with cross-functional teams to optimize app performance, enhancing user engagement and experience."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true
};
// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle:
    "STARTUPS AND COMPANIES I HAVE SUPPORTED IN BUILDING THEIR TECHNOLOGY",
  projects: [
    {
      image: "https://fikra-media.s3.eu-central-1.amazonaws.com/img1.jpeg?v=1",
      projectName: "Fikra",
      projectDesc:
        "Fikra is a bilingual Palestinian literary magazine that showcases thought-provoking essays, short stories, poetry, and visual art in both English and Arabic.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://fikra-magazine.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image:
        "https://broccoli-agency-media.s3.eu-central-1.amazonaws.com/Images/home-og-image.png",
      projectName: "Broccoli Agency",
      projectDesc:
        "A comprehensive IT solutions provider specializing in IT consultancy, staffing, cloud services, AI integration, digital marketing, and custom app development",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://broccoli-agency.com/"
        }
      ]
    }
  ]
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Mobile Development (React Native)",
      subtitle:
        "Recognized as one of the top 3 students in a comprehensive React Native course, where I demonstrated strong skills in building mobile applications using React Native. This recognition led to a recommendation and my first job in the industry.",
      image: require("./assets/images/digital_institute.webp"),
      imageAlt: "Digital Institute logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1fkXe4q4uOXz0OfFV9CiNY1BOJy7LKVrU/view?usp=sharing"
        },
        {
          name: "View Final Project on GitHub",
          url: "https://github.com/romeonatchkebia/Uber-Eats-App"
        },
        {
          name: "View Final Project Demo",
          url: "https://drive.google.com/file/d/19qA1Gqo9Xz8BhqQYrfQPt1vn0ab_E4Ru/view?usp=drive_link"
        }
      ]
    }
  ]
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "Passionate about creating cool projects, I enjoy writing and sharing what I’ve learned to help others grow.",
  displayMediumBlogs: "true",
  blogs: [
    {
      url: "https://medium.com/@romeo.nachkebia/solving-cors-issues-when-using-partytown-with-next-js-7da7c965ae20",
      title: "Solving CORS Issues When Using Partytown with Next.js",
      description:
        "This blog explains how to fix CORS issues when using Partytown with Next.js to optimize web performance by offloading third-party scripts to web workers"
    }
  ]
};

const contactInfo = {
  title: emoji("Contact Me"),
  subtitle:
    "Want to discuss a project or just say hi? My inbox is always open!",
  number: "+995 591 54 03 08",
  email_address: "romeonatchkebia@gmail.com"
};

export {
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  contactInfo
};
